import React from 'react';
import { cn } from '@/utils/styles';
import { ConnectionIcon } from '@/components/icons/ConnectionIcon';

interface ConditionsCardProps {
  id: number;
  name: string;
  rank: string;
  rankColor: string;
  onClick?: () => void;
}

export const ConditionsCard: React.FC<ConditionsCardProps> = ({
  id,
  name,
  rank,
  rankColor,
  onClick,
}) => {
  return (
    <button
      key={`${name}-${id}-condition`}
      onClick={onClick}
      className={cn(
        'p-5 rounded-lg flex justify-between items-center shadow-md bg-[#42434D73] hover:shadow-lg transition-shadow text-left w-full',
      )}
    >
      <div className="flex items-center justify-start">
        <ConnectionIcon />
        <div className="ml-4">
          <h3 className="typography-title text-primary" title={name}>
            {name}
          </h3>
          <p className="typography-body" style={{ color: rankColor }}>
            {rank}
          </p>
        </div>
      </div>
    </button>
  );
};
